import { render, staticRenderFns } from "./smwj.vue?vue&type=template&id=4158ee50&scoped=true"
import script from "./smwj.vue?vue&type=script&lang=js"
export * from "./smwj.vue?vue&type=script&lang=js"
import style0 from "./smwj.vue?vue&type=style&index=0&id=4158ee50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158ee50",
  null
  
)

export default component.exports